import displayError from '@/helpers/displayError'
import { store } from '@/store/index.js'
import moment from 'moment'

function loadResource (Resource, type, isLoadingType = false, params) {
  if (isLoadingType) {
    store.dispatch(isLoadingType, true)
  }
  Resource.index(params).then((response) => {
    store.dispatch(type, response.data)
    if (isLoadingType) {
      store.dispatch(isLoadingType, false)
    }
  }).catch((error) => {
    displayError(error)
  })
}

function deleteResource (type, resource) {
  swal({
    title: 'Please confirm this action',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.value) {
      store.dispatch(type, resource)
    }
  })
}

function search (Resource, type, isLoading, search) {
  store.dispatch(isLoading, true)
  Resource.index(search).then((response) => {
    store.dispatch(isLoading, false)
    store.dispatch(type, response.data)
  }).catch((error) => {
    displayError(error)
  })
}

function getDate (date) {
  if (date) {
    return moment(date).format('DD.MM.YYYY - HH:MM')
  }

  return 'Invalid format'
}

export {loadResource, deleteResource, getDate, search}



// WEBPACK FOOTER //
// ./src/helpers/resource.js